
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 39","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.545 12.455L14.091 1M30.455 12.455L23.909 1M33.727 21.455v12.977a3.273 3.273 0 01-3.272 3.273H7.545a3.273 3.273 0 01-3.272-3.273V21.455M1 12.455h36v4.909H1zM19 23.091v9M12.455 23.091v9M25.545 23.091v9"}})])])
          )
        }
      }
    